import { common } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
import deepmerge from 'deepmerge';
import { base, DefaultPalette } from './base';

export type MuiColor = 'background' | 'primary' | 'secondary';
export type MuiPalette = Record<MuiColor, DefaultPalette>;

export const muiPalette: MuiPalette = {
  background: {
    default: common.white,
    main: common.white,
    contrastText: base.palette.bone.contrastText,
  },
  primary: {
    main: base.palette.tussock.main,
    contrastText: base.palette.tussock.contrastText,
  },
  secondary: {
    main: base.palette.sand.main,
    contrastText: base.palette.sand.contrastText,
  },
};

const mui = createTheme({
  breakpoints: { values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 } },
  palette: { mode: 'light', ...muiPalette },
  components: {
    MuiButton: { styleOverrides: { root: { textTransform: 'none' } } },
    MuiCssBaseline: {
      styleOverrides: { body: { fontSize: '0.875rem', letterSpacing: '0.01071em', lineHeight: 1.43 } },
    },
    MuiLink: { styleOverrides: { root: { textDecoration: 'none' } } },
  },
  typography: { fontFamily: ['Lausanne', 'Arial'].join(', ') },
});

export const light = {
  mui,
  styled: deepmerge(mui, base),
};
